import typescript from '../resources/typescript.webp'
import reactImg from '../resources/ReactImg.webp'
import SQL from '../resources/SQL.webp'
import JS from '../resources/JS.webp'
import csharp from '../resources/csharp.webp'
import AWS from '../resources/AWS.webp'
import python from '../resources/python.webp'
import { Link } from 'react-router-dom'

const MainSection = () => {
  return (
    <div className="main">
      <div className="intro">Hi, my name is</div>
      <Link to="/about">
        <div className="name">Nick Amenda.</div>
      </Link>
      <div className="info">I create innovative solutions.</div>
      <div className="description">
        <p>
          I am a passionate full-stack software engineer dedicated to creating seamless, user-friendly experiences. 
          With a strong focus on solving real-world problems through technology, I take pride in crafting efficient, 
          scalable solutions that enhance the user experience.
        </p> 
      </div>
      <div style={{color: 'var(--secondary-text)', fontSize: '1.1rem', marginTop: '1rem'}}>
        I am proficient with many different technologies and languages. Here are a few examples!
      </div>
      <div className="aboutMe skills">
        <div className="reactImg">
          <a href="https://reactjs.org/" target="_blank" rel="noreferrer">
            <img src={reactImg} alt="react logo" title="React"></img>
          </a>
        </div>
        <div className="JS">
          <a href="https://www.javascript.com/" target="_blank" rel="noreferrer">
            <img src={JS} alt="js logo" title="JavaScript"></img>
          </a>
        </div>
        <div className="HTML">
          <a href="https://www.typescriptlang.org/" target="_blank" rel="noreferrer">
            <img src={typescript} alt="typescript logo" title="TypeScript"></img>
          </a>
        </div>
        <div className="CSS">
          <a href="https://www.python.org/about/" target="_blank" rel="noreferrer">
            <img src={python} alt="python logo" title="Python"></img>
          </a>
        </div>
        <div className="Mongo">
          <a href="https://dotnet.microsoft.com/en-us/languages/csharp" target="_blank" rel="noreferrer">
            <img src={csharp} alt="csharp logo" title="C#"></img>
          </a>
        </div>
        <div className="AWS">
          <a href="https://aws.amazon.com/" target="_blank" rel="noreferrer">
            <img alt="aws logo" src={AWS} title="AWS"></img>
          </a>
        </div>
        <div className="SQL">
          <a href="https://www.mysql.com/" target="_blank" rel="noreferrer">
            <img src={SQL} alt="sql logo" title="SQL"></img>
          </a>
        </div>
      </div>
    </div>
  )
}

export default MainSection;
